const getLocalFileUrl = file => file?.localFile?.publicURL || null

const getValidDownloads = (items, fileField = "downloadLinkDatei") =>
  (Array.isArray(items) ? items : []).flatMap((item, index) => {
    const url = getLocalFileUrl(item?.[fileField])

    return url ? [{ item, index, url }] : []
  })

const collectInvalidDownloadReferences = (
  pages,
  fileField = "downloadLinkDatei"
) =>
  (Array.isArray(pages) ? pages : []).flatMap(page => {
    const downloads =
      page?.pagebuilder?.weiterfuehrendeLinksUndDownloads?.downloadsBottom

    return (Array.isArray(downloads) ? downloads : []).flatMap(
      (item, index) => {
        const hasContent = Boolean(item?.downloadLinkText || item?.[fileField])
        const url = getLocalFileUrl(item?.[fileField])

        return hasContent && !url
          ? [
              {
                pageTitle: page.title || "Untitled page",
                pageUri: page.uri || "(no URI)",
                downloadLabel: item.downloadLinkText || `row ${index + 1}`,
              },
            ]
          : []
      }
    )
  })

module.exports = {
  collectInvalidDownloadReferences,
  getLocalFileUrl,
  getValidDownloads,
}
